import { createSelector } from "reselect";

const selectAdminInspectorsDomain = (state) => state.get("adminInspectors");

export const selectAdminInspectors = createSelector(
  selectAdminInspectorsDomain,
  (state) => {
    const adminInspectors = state.getIn(["data", "items"]).toJS();
    // console.log("inspector list from state", adminInspectors);
    return adminInspectors || [];
  }
);
